import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatSortModule,
    MatMenuModule,
    MatDatepickerModule,
    MatBottomSheetModule,
  ],
  exports: [
    MatSnackBarModule,
    MatDialogModule,
    MatSortModule,
    MatMenuModule,
    MatDatepickerModule,
    MatBottomSheetModule,
  ],
})
export class AngularMaterialModule {}
